import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";

import SalesTaxesFields from "./SalesTaxesFields";

const SalesTaxesPage = () => {
  return (
    <div>
      <div className="page-header">
        <div className="main clearfix">
          <div className="main-name">
            <h2>
              <FormattedMessage id="salesTaxes.title" />
            </h2>
          </div>
        </div>
      </div>
      <div className="sub-container">
        <SalesTaxesFields />
      </div>
    </div>
  );
};

SalesTaxesPage.propTypes = {
  children: PropTypes.node,
};

export default SalesTaxesPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/sales-taxes/SalesTaxesPage.js